import Repository from "./Repository";
import Company from "../types/Company";
import EmployeeBulkUploadRequest from "../types/EmployeeBulkUploadRequest";
import BaseResponse from "../types/BaseResponse";

const resource = "/company";

export default {
  get() {
    return Repository.get(`${resource}/searchByEmployee`);
  },
  getCompaniesByEmployee() {
    return Repository.get<BaseResponse<Company[]>>(
      `${resource}/searchByEmployee`
    );
  },
  getOne(id: string) {
    return Repository.get<BaseResponse<Company>>(`${resource}/${id}`);
  },
  byCompanyCode(code: string) {
    return Repository.get(`${resource}/companyCode/${code}`);
  },
  create(company: Company) {
    return Repository.post(`${resource}`, company);
  },
  update(company: Company) {
    return Repository.patch(`${resource}`, company);
  },
  getTypes() {
    return Repository.get(`/industries`);
  },
  employeeBulkUpload(
    companyId: string,
    employeeBulkUploadRequest: EmployeeBulkUploadRequest
  ) {
    return Repository.post(
      `${resource}/${companyId}/uploadEmployees`,
      employeeBulkUploadRequest
    );
  },
  uploadLogo(companyId: string, data: FormData) {
    return Repository.post(`${resource}/${companyId}/uploadLogo`, data);
  },
  uploadTemporaryLogo(data: FormData) {
    return Repository.post(`${resource}/uploadTemporaryImage`, data);
  },
  sendDefaultPassword(companyId: string) {
    return Repository.get<BaseResponse>(
      `${resource}/${companyId}/sendDefaultPassword`
    );
  },
  getParentEligibleCompanies() {
    return Repository.get<BaseResponse<Company[]>>(
      `${resource}/parentCompanies`
    );
  },
};
